import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import Swal from 'sweetalert2';
import { IUser } from 'src/app/_interfaces/IUser.types';
import { AuthService } from 'src/app/_services/auth.service';
import { UserService } from 'src/app/_services/user.service';
import { RoutingService } from 'src/app/_services/routing.service';
import { ChatService } from 'src/app/_services/chat_service';
import { MatDialog } from '@angular/material/dialog';
import { SendNotificationComponent } from '../send-notification/send-notification.component';
import { NotificationAlertComponent } from '../notification-alert/notification-alert.component';
import { getMessaging, onMessage } from 'firebase/messaging';
import { onBackgroundMessage } from 'firebase/messaging/sw';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NavbarComponent implements OnInit {
  user!: IUser;
  isOpen: boolean = false;
  page: number = 1;
  count: number = 5;
  showLoader: boolean = false;
  notificaitons: any[] = [];
  showSeeMore: boolean = true;
  unReadCount:any;

  constructor(
    private _authService: AuthService,
    private _userService: UserService,
    public routing: RoutingService,
    private chatManagement: ChatService,
    private dialogRef : MatDialog
  ) {
    this._userService.userObservable.subscribe((user: IUser) => {
      this.user = user;
    });
  }

  async ngOnInit() {
    this.getUnReadNotificationsCount();
    this.listenForegroundMessages();
  }

  logout() {
    Swal.fire({
      title: 'Log Out',
      text: 'Sure you want to Log Out',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Log Out',
      confirmButtonColor: '#0b5455',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.value) {
        this._authService.logout({ deviceId: this._authService.deviceId });
      }
    });
  }

  goToChatListing() {
    this.routing.goToChatListing();
  }

  openDeclinedPopup(data:any) {
    const dialogRef = this.dialogRef.open(NotificationAlertComponent, {
      panelClass: 'ReasonDeclined',
      hasBackdrop: true,
      data: { bookingInfo: data},
    });
    dialogRef.afterClosed().subscribe((res: any) => {
    });
  }

  listenForegroundMessages() {
    const messaging = getMessaging();
    onMessage(messaging, (payload) => {
      this.getUnReadNotificationsCount();
      this.openDeclinedPopup(payload.notification);
    });
    onBackgroundMessage(messaging, (payload2: any) => {
      this.getUnReadNotificationsCount();
    });
  }

  openDrop() {
    this.isOpen = !this.isOpen;
    this.unReadCount = 0;
    if(this.isOpen){
      this.getNotifications();
    }else{
      this.removeNotifications();
    }
  }

  seeMore() {
    this.page = this.page + 1;
    this.getNotifications();
  }

  removeNotifications(){
    this.notificaitons = [];
    this.page = 1;
  }

  getNotifications() {
    this.showLoader = true;
    let query = `?page=${this.page}&count=${this.count}`;
    this.chatManagement.getNotifications(query).subscribe({
      next: (response: any) => {
        if (response && response.isSuccess) {
          if (!response.data.length) {
            this.showSeeMore = false;
          }
          this.notificaitons = [...this.notificaitons, ...response.data];
        }
        this.showLoader = false;
      },
      error: (errorResponse: any) => {
        this.showLoader = false;
      },
    });
  }

  getUnReadNotificationsCount(){
    this.showLoader = true;
    this.chatManagement.getUnReadNotifications().subscribe({
      next: (response: any) => {
        if (response && response.isSuccess) {
          this.unReadCount = response.data.count;
        }
        this.showLoader = false;
      },
      error: (errorResponse: any) => {
        this.showLoader = false;
      },
    });
  }

  goToDetail(item: any) {
    if (item.notificationType === 'booking') {
      this.isOpen = false;
      this.routing.goToBookingList();
    } else if (item.notificationType === 'refund') {
      this.isOpen = false;
      this.routing.goToRefundList();
    } else if (item.notificationType === 'service') {
      this.isOpen = false;
      this.routing.goToServiceList();
    } else if (item.notificationType === 'location') {
      this.isOpen = false;
      this.routing.goToLocationList();
    } else if (item.notificationType === 'complaint') {
      this.isOpen = false;
      this.routing.goToComplaintList();
    } else if (item.notificationType === 'lead') {
      this.isOpen = false;
      this.routing.goToLeadList();
    } else if (item.notificationType === 'comboPackage') {
      this.isOpen = false;
      this.routing.goToComboPackageList();
    } else if (item.notificationType === 'comboBooking') {
      this.isOpen = false;
      this.routing.goToComboBookingList();
    } else if (item.notificationType === 'partnerAvailability') {
      // A partner's request waits for a decision (bookings: partner-availability-mode).
      this.isOpen = false;
      this.routing.goToPartnerAvailability();
    }
  }

  openDialog(){
    this.dialogRef.open(SendNotificationComponent);
  }


}
